/* Men's crew-socks PDP upsell — colour choice + add via the theme's cart API.

   Colours are separate products (radio swatches carry each one's variant id, price,
   compare-at and image). The store's active product-form build ignores the native `bundles`
   hook in its AJAX (drawer) path, so we add the selected sock ourselves — but we mirror the
   theme's own add: request the cart drawer's sections, publish cartUpdate (so the drawer +
   count re-render), then open the drawer. That is the shopper's acknowledgement, exactly like
   a normal Add to Cart, so there is no separate "Added" state to go stale when they later
   remove it from the cart. */
if (!customElements.get('sock-upsell')) {
  customElements.define(
    'sock-upsell',
    class SockUpsell extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sock-add]');
        this.priceEl = this.querySelector('[data-sock-price]');
        this.compareEl = this.querySelector('[data-sock-compare]');
        this.imgEl = this.querySelector('[data-sock-img]');
        this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        if (!this.button || this.radios.length === 0) return;
        this.radios.forEach((r) => r.addEventListener('change', () => this.sync()));
        this.button.addEventListener('click', this.add.bind(this));
        this.sync();
      }

      get selected() {
        return this.radios.find((r) => r.checked) || this.radios[0];
      }

      // Reflect the chosen colour's price / compare-at / image.
      sync() {
        const r = this.selected;
        if (!r) return;
        if (this.priceEl) this.priceEl.textContent = r.dataset.price || '';
        if (this.compareEl) {
          const c = r.dataset.compare || '';
          this.compareEl.textContent = c;
          this.compareEl.hidden = !c;
        }
        if (this.imgEl && r.dataset.img) this.imgEl.src = r.dataset.img;
      }

      add() {
        if (this.busy) return;
        const variantId = this.selected && this.selected.value;
        if (!variantId) return;
        this.busy = true;
        this.button.setAttribute('aria-busy', 'true');

        // The cart drawer listens for this and pushes its section id, so the add response
        // returns the drawer's re-rendered HTML.
        const sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } })
        );

        const config = theme.utils.fetchConfig('javascript');
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        });

        fetch(theme.routes.cart_add_url, config)
          .then((response) => response.json())
          .then(async (parsed) => {
            if (parsed.status) {
              console.error('[sock-upsell]', parsed.description);
              return;
            }
            const cart = await (
              await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })
            ).json();
            cart.sections = parsed.sections;
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'sock-upsell',
              productVariantId: variantId,
              cart,
            });
            // Open the cart drawer — the standard add-to-cart acknowledgement.
            document.querySelector('cart-drawer')?.show();
          })
          .catch((error) => console.error('[sock-upsell]', error))
          .finally(() => {
            this.busy = false;
            this.button.removeAttribute('aria-busy');
          });
      }
    }
  );
}
